import {EventPublicAssetMode} from "./GraphQL/generated/graphql";

export {EventPublicAssetMode};

export type EventPublicAssetModeValue = EventPublicAssetMode;

export const DEFAULT_EVENT_PUBLIC_ASSET_MODE: EventPublicAssetModeValue =
    EventPublicAssetMode.SeparateProgramAndLayout;

export const normalizeEventPublicAssetMode = (
    value?: string | number | null
): EventPublicAssetModeValue => {
    if (value === 0 || value === "0") {
        return EventPublicAssetMode.SeparateProgramAndLayout;
    }

    if (value === 1 || value === "1") {
        return EventPublicAssetMode.CombinedPdf;
    }

    const normalized = String(value ?? "")
        .replace(/[_\s-]+/g, "")
        .toLowerCase();

    if (normalized === "combinedpdf") {
        return EventPublicAssetMode.CombinedPdf;
    }

    if (normalized === "separateprogramandlayout") {
        return EventPublicAssetMode.SeparateProgramAndLayout;
    }

    return DEFAULT_EVENT_PUBLIC_ASSET_MODE;
};
